module.exports = __webpack_public_path__ + "static/media/12.2f3a5a52.mp3";